<template>
  <div>
    <o-field-group :label="_option.name">
      <select-field v-model="_option.value" :options="options" />
    </o-field-group>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import {
  OFieldGroup,
} from '@/components/elements'

import {
  SelectField,
} from '@/components/fields'

interface Props {
  option: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:option', value: Record<string, any>): void
}>()

const _option = computed({
  get () {
    return props.option
  },
  set (value) {
    emit('update:option', value)
  },
})

const options = computed(() => {
  const entries = Object.entries(props.option.values)
  return entries
    .map(([value, label]) => {
      return {
        label,
        value,
      }
    })
})
</script>
